import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/dimension.constant";

export {
    addDimensions,
    addSingleDimension,
    updateSingleDimension,
    getSingleDimension,
    getAllDimensions,
    searchDimensions,
    searchDimensionsWithSearchCriteria,
    prepareDimensionsList
}

const collectionName = 'dimensions';
const collectionReference = collection(fireStoreDB, collectionName);

const addDimensions = (dimensions) => {
    return Promise.map(dimensions, async dimension => {
        await addSingleDimension(dimension);
    });
}

const addSingleDimension = (dimension) => {
    dimension.createdAt = new Date();
    dimension.updatedAt = dimension.createdAt;
    return addDoc(collectionReference, dimension);
}

const updateSingleDimension = (dimension) => {
    const documentReference = doc(fireStoreDB, collectionName, dimension.id);
    dimension.updatedAt = new Date();
    return setDoc(documentReference, dimension);
}

const getSingleDimension = async (dimensionId) => {
    const documentReference = doc(fireStoreDB, collectionName, dimensionId);
    const dimensionDoc = await getDoc(documentReference);
    return prepareSingleDimension(dimensionDoc);
}

const getAllDimensions = async () => {
    let searchQuery = query(collectionReference);
    const dimensionsResult = await getDocs(searchQuery);
    return prepareDimensionsList(dimensionsResult);
}

const searchDimensions = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const dimensionResult = await getDocs(searchQuery);
    return prepareDimensionsList(dimensionResult);
}

const searchDimensionsWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchDimensionsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const dimensionResult = await getDocs(searchQuery);
    return prepareDimensionsList(dimensionResult);
}

const prepareDimensionsList = (dimensionResult) => {
    const dimensionsList = [];

    _.forEach(dimensionResult.docs, dimensionDoc => {
        dimensionsList.push(prepareSingleDimension(dimensionDoc));
    });

    return dimensionsList;
}


const prepareSingleDimension = (dimensionDoc) => {
    const dimension = dimensionDoc.data();
    dimension.id = dimensionDoc.id;
    return dimension;
}
